/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Kpi_No_CustomersInputs */



/**
* | output |
* | --- |
* | "No customers yet" |
*
* @param {Partner_Admin_Kpi_No_CustomersInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_kpi_no_customers = /** @type {((inputs?: Partner_Admin_Kpi_No_CustomersInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Kpi_No_CustomersInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Noch keine Kunden")
	return /** @type {LocalizedString} */ ("No customers yet")
});